




























































import { Vue, Component } from "vue-property-decorator";
import { userModule } from "@/store/modules/user";
import { roleListModule } from "@/store/modules/roleList";

@Component
export default class RoleList extends Vue {
  public dialog = false;
  public headers = [
    {
      text: "用戶",
      align: "start",
      value: "name"
    },
    { text: "權限組", value: "roles" },
    { text: "Actions", value: "actions", sortable: false }
  ];

  public role_item = [];
  public admin_role = ["Developer", "Doctor", "Paramedic", "Patient"];
  public owner_role = ["Admin", "Developer", "Doctor", "Paramedic", "Patient"];

  get user() {
    return userModule.user;
  }

  get loading() {
    return roleListModule.loading;
  }

  get accounts() {
    return roleListModule.accounts;
  }

  get account() {
    return roleListModule.account;
  }

  set account(item) {
    roleListModule.setAccount(item);
  }

  created() {
    roleListModule.roleList();
    if (this.user.roles.includes("Owner")) {
      this.role_item = this.role_item.concat(this.owner_role);
    } else if (this.user.roles.includes("Admin")) {
      this.role_item = this.role_item.concat(this.admin_role);
    }
  }

  editItem(item) {
    this.account = Object.assign({}, item);
    this.dialog = true;
  }

  public async save() {
    roleListModule.replaceRole();
    this.dialog = false;
  }
}
